export default __webpack_public_path__ + "resources/icons/d310-1e6f.png";